import defaultAvatar from '@/../public/avatar.png';

export const getAvatarSrc = avatar => avatar || defaultAvatar;

export const setDefaultAvatar = event => {
    if (event?.target?.src !== defaultAvatar) {
        event.target.src = defaultAvatar;
    }
};

export default defaultAvatar;
